exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body .form-group span[data-v-45c4d11e]{font-size:15px;padding-top:5px;padding-left:5px}.modal-body .modal-loader[data-v-45c4d11e]{width:100px}.modal-body label[data-v-45c4d11e]{font-weight:700!important}.modal-body .info-text[data-v-45c4d11e]{margin:0 0 30px;font-size:15px;text-align:justify;text-align:center;line-height:1.5em}.modal-body .invalid[data-v-45c4d11e]{display:block;font-size:12px!important;color:#f54b53}.modal-body .bottom-buttons[data-v-45c4d11e]{text-align:center}.modal-body .btn__normal[data-v-45c4d11e]{margin:12px;width:170px;height:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45c4d11e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/user/changeUserPassword.vue
// module id = TONf
// module chunks = 0